export interface Notification {
  id: string;
  userId: string;
  title: string;
  message: string;
  type: NotificationType;
  status: NotificationStatus;
  data?: any;
  link?: string;
  createdAt: Date;
}

export enum NotificationType {
  CAMPAIGN = 'CAMPAIGN',
  CLIENT = 'CLIENT',
  SUBSCRIPTION = 'SUBSCRIPTION',
  SYSTEM = 'SYSTEM',
  USER = 'USER'
}

export enum NotificationStatus {
  READ = 'READ',
  UNREAD = 'UNREAD'
}
